import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload';
import { DndModule } from 'ngx-drag-drop';
// eslint-disable-next-line max-len
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SkuService } from '../home/services/studio/sku.service';
import { SharedModule } from '../shared/shared.module';
import { IIShapesSharedForbiddenComponent } from './forbidden/forbidden.component';
import { ViewerService } from './link-service.service';
import { IIShapesPasswordDialogComponent } from './password-dialog/password-dialog.component';
import { ViewerComponent } from './viewer/viewer.component';
import { MakerWelcomeComponent } from './welcome/maker-welcome.component';



const appRoutes: Routes = [
  { path: '', component: MakerWelcomeComponent },
  { path: 'forbidden', component: IIShapesSharedForbiddenComponent },
  { path: ':id', component: ViewerComponent },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(appRoutes);

@NgModule({
  declarations: [
    MakerWelcomeComponent,
    ViewerComponent,
    IIShapesPasswordDialogComponent,
    IIShapesSharedForbiddenComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    TranslateModule,
    RouterModule.forChild(appRoutes),
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDialogModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    ReactiveFormsModule, MatAutocompleteModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatCardModule,
    MatStepperModule,
    MatExpansionModule,
    MatSliderModule,
    MatButtonToggleModule,
    MatOptionModule,
    FileUploadModule,
    MatProgressBarModule,
    MatMenuModule,
    MatSnackBarModule,
    MatSidenavModule,
    FormsModule,
    MatIconModule,
    MatChipsModule,
    MatToolbarModule,
    DragDropModule,
    DndModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatCheckboxModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
  ],
  providers: [
    ViewerService,
    SkuService,
    DeviceDetectorService
  ]
})
export class LinkModule { }
